import { lazy, Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { ContentContext, useAnalytics } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';
import { SettingsCache } from '~/lib/consts/settings-cache';
import useGoto from '~/hooks/use-goto';

const Referrals = lazy(() => import('~/apps/rewards/referrals'));

export default function Component() {
  const { goTo } = useGoto();
  const { track } = useAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.REWARDS);

  useOnLoad(() => {
    if (!SettingsCache.settings.Features.includes('Referrals')) {
      goTo(RoutingConstants.MyAccount);
      return;
    }

    const title = t('REFERRALS_PAGE_TITLE', { defaultValue: 'Referrals' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.REWARDS });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.Referrals }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.Referrals
      }
    });
  });

  return (
    <Tagged tag="screen-referrals">
      <Suspense>
        <Referrals />
      </Suspense>
    </Tagged>
  );
}

Component.displayName = 'Referrals';
